/**
 * Nastavitve razvrščanja, kot veljajo za eno podjetje.
 *
 * Tabele so enake preglednicam, iz katerih se razvrščanje ureja: vrstica je
 * skupina ali postavka, konti pa so našteti v enem polju. Standardna shema
 * velja vsem strankam; kar se tu spremeni, se zapiše kot prilagoditev tega
 * podjetja in pri drugih strankah ne velja (docs/ARHITEKTURA.md, 4.4).
 */
/**
 * Vloge vrst temeljnic (docs/ARHITEKTURA.md, 5.9 in 15).
 *
 * `navadna` je privzeto; `otvoritev` pomeni, da gredo knjižbe te vrste ob
 * uvozu v obdobje 0; `zapiranje` označi zaključne temeljnice, ki jih izkaz
 * poslovnega izida izloči (bilanca jih obdrži); `zapiranje_bilance` označi
 * temeljnice, ki na koncu leta zaprejo bilančne konte na nič – te so izločene
 * povsod (poročila, razčlenitev, ujemanje in izračun otvoritve).
 * `amortizacija` (iz teh knjižb se bere mesečna amortizacija po sredstvih) in
 * `popravek_amortizacije` (preknjižbe iz temeljnic portala) sta za modul
 * Projekti. Privzetkov v kodi ni — nastavi jih skrbnik.
 */
export const VLOGE_TEMELJNIC = [
    'navadna',
    'otvoritev',
    'zapiranje',
    'zapiranje_bilance',
    'amortizacija',
    'popravek_amortizacije',
];
/** Šifre kontov iz vnosnega polja; loči jih podpičje, vejica ali presledek. */
export function kontiIzVnosa(besedilo) {
    return [
        ...new Set(besedilo
            .split(/[,;\s]+/)
            .map((d) => d.trim())
            .filter((d) => d !== '' && d.toLowerCase() !== 'x')),
    ];
}
/** Zapis kontov v polje, kot ga uporabnik vidi. */
export function vnosIzKontov(konti) {
    return konti.join('; ');
}
//# sourceMappingURL=prilagoditve.js.map